export const sub = (template, options) => {
    if (template) {
        Object.keys(options || {}).forEach(k => {
            template = template.replace(`{${k}}`, options[k]);
        })
    }
    return template;
}